import AplifisaRoutes from './aplifisa/aplifisa.routes';
import FiscalObligationsRoutes from './fiscal-obligations/fiscal-obligations.routes';
import AccountingControlRoutes from './accounting-control/accounting-control.routes';
import AdminConversations from './conversations/conversations.routes';
import CustomersAndConsultantsRoutes from './customers-and-consultants/customers-and-consultant.routes';
import DocumentsRoutes from './documents/documents.routes';
import CalendarRoutes from './calendar/calendar.routes';
import LopdRoutes from './lopd/lopd.routes';
import BroadcastMessagesRoutes from './broadcast-messages/broadcast-messages.routes';
import LaboralRoutes from './laboral/laboral.routes';
import BillingRoutes from './billing/billing.routes';
import ReportsRoutes from './reports/reports.routes';

export default [
  {
    name: 'Administración',
    icon: 'mdi-security',
    path: '/admin',
    redirect: '/admin/conversations',
    meta: {
      requiresAuth: true,
      admin: true,
      toolbar: true,
      rightToolbar: true,
      tooltip: null,
    },
  },

  ...AdminConversations,
  ...DocumentsRoutes,
  ...AplifisaRoutes,
  ...FiscalObligationsRoutes,
  ...AccountingControlRoutes,
  ...BillingRoutes,
  ...LaboralRoutes,
  ...CustomersAndConsultantsRoutes,
  ...CalendarRoutes,
  ...LopdRoutes,
  ...BroadcastMessagesRoutes,
  ...ReportsRoutes,

  // {
  //   name: 'Ver sitio',
  //   icon: 'mdi-eye-outline',
  //   path: '/dashboard',
  //   meta: {
  //     admin: true,
  //     adminToolbar: true,
  //     adminRightToolbar: true,
  //     adminDrawer: true,
  //     tooltip: null,
  //   },
  // },
];
